import axiosConfig from "./axiosConfig";

export interface VoaRatingListStatusResponse {
  activeRowCount: number;
  totalRowCount: number;
  latestSourceRevision: string | null;
  latestSeenAt: string | null;
}

export const getVoaRatingListStatus = async (
  authToken: string
): Promise<VoaRatingListStatusResponse> => {
  const { data } = await axiosConfig.get("/leads/voa-status", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};
